import { writable } from 'svelte/store';
import { ethers } from "ethers";
import * as erc20abi from './contracts/erc20abi.json';
import * as sinupoolabi from './contracts/sinupoolabi.json';
import * as uniswapoolabi from './contracts/uniswapoolabi.json';

// <-- Constants -->

var networkId       = window.networkId       = 245022926;
var sinuDecimals    = window.sinuDecimals    = 18;
var neonDecimals    = window.neonDecimals    = 17;
var sinuTotalSupply = window.sinuTotalSupply = 100_000_000;

var sinuAddress     = window.sinuAddress     = '0xf6f9d7e6dab706119b731d25ae242e784a96bf1f';

// Three pools addresses
var neonPoolAddress = window.neonPoolAddress  = '0x468355A37d2B1b4BC4888fbb5670A30D4ae3cFE6';
var slpPoolAddress  = window.slpPoolAddress  = '0x3ef34940e4074822588eEAEAAED0bd73DeC4F7eE';
var sinuPoolAddress = window.sinuPoolAddress = '0x82570Bb597e3bB92b15e69DfFBA05aDd3e73F0BF';

var masterChef      = window.masterChef      = '0x0a5bD0108227B3DFeC64199D6939841eeCF47a8E';
var slpAddress      = window.slpAddress      = '0xb92641d91be28904b57a8afb9236eafd282e23bd';

var sinuNeonUniPool = window.sinuNeonUniPool = '0x7a250d5630b4cf539739df2c5dacb4c659f2488d';
var wethAddress     = window.wethAddress     = '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6';
var usdtAddress     = window.usdtAddress     = '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984';

// <-- Connected  -->
export const connected = writable((JSON.parse(localStorage.connected || 'false') === true) || false);
connected.subscribe((value) => localStorage.connected = value);

// <-- Notification -->

export const notification = writable(
  (Object.keys(JSON.parse(localStorage.notification || '{}')).length === 0) ?
    {
      type:       '',
      message:    '',
      visibility: true,
      duration: 10000,
      txid: null,
    } :
    JSON.parse(localStorage.notification)
);

notification.subscribe((value) => localStorage.notification = JSON.stringify(value));

// <-- Wallet Data -->

export const walletData = writable(
  (Object.keys(JSON.parse(localStorage.walletData || '{}')).length === 0) ?
    {
      networkId: networkId,
      networkIdHex: networkId.toString(16),
      address: '',
      sinuAmount: null,
      slpAmount: null,
      neonStakedAmount: null,
      sinuStakedAmount: null,
      slpStakedAmount: null,
      neonClaimableAmount: null,
      sinuClaimableAmount: null,
      slpClaimableAmount: null,
      neonAmount: null,
      sinuApprovedAmount: null,
      slpApprovedAmount: null,
    } :
    JSON.parse(localStorage.walletData)
);

walletData.subscribe((value) => localStorage.walletData = JSON.stringify(value));

// <-- Price Data -->

export const priceData = writable(
  (Object.keys(JSON.parse(localStorage.priceData || '{}')).length === 0) ?
    {
      marketCap: 30,
      totalValueLocked: null,
      sinuPrice: null
    } :
    JSON.parse(localStorage.priceData)
);

priceData.subscribe((value) => localStorage.priceData = JSON.stringify(value));

// <-- Local Provider -->

const localProvider = new ethers.providers.StaticJsonRpcProvider('https://proxy.devnet.neonlabs.org/solana', { name: 'Neon', chainId: networkId });
var privateKey      = '000000000000000000000000000000000000000000000000000000000000000f';
var wallet          = new ethers.Wallet(privateKey,localProvider);

// <-- Sinu Contract -->
var sinuContract               = new ethers.Contract(sinuAddress,erc20abi.default,wallet);
export const sinuLocalContract = writable(sinuContract);
window.sinuLocalContract       = sinuContract;

// <-- Slp Contract -->
var slpContract                = new ethers.Contract(slpAddress,erc20abi.default,wallet);
export const slpLocalContract  = writable(slpContract);
window.slpLocalContract        = slpLocalContract;

// <-- Neon Pool Contract -->
var neonPoolContractAddress        = neonPoolAddress;
var neonPoolContract               = new ethers.Contract(neonPoolContractAddress,sinupoolabi.default,wallet);
export const neonPoolLocalContract = writable(neonPoolContract);
window.neonPoolLocalContract       = neonPoolContract;

// <-- Sinu Pool Contract -->
var sinuPoolContractAddress        = sinuPoolAddress;
var sinuPoolContract               = new ethers.Contract(sinuPoolContractAddress,sinupoolabi.default,wallet);
export const sinuPoolLocalContract = writable(sinuPoolContract);
window.sinuPoolLocalContract       = sinuPoolContract;

// <-- Pool Contract -->
var slpPoolContractAddress        = slpPoolAddress;
var slpPoolContract               = new ethers.Contract(slpPoolContractAddress,sinupoolabi.default,wallet);
export const slpPoolLocalContract = writable(slpPoolContract);
window.slpPoolLocalContract       = slpPoolContract;
export const slpPoolLocalContractAddress = writable(slpPoolContractAddress);

// <-- SinuNeonUniPool Contract -->
var sinuNeonUniPoolContractAddress         = sinuNeonUniPool;
var sinuNeonUniPoolContract                = new ethers.Contract(sinuNeonUniPoolContractAddress,uniswapoolabi.default,wallet);
export const sinuNeonUniPoolLocalContract  = writable(sinuNeonUniPoolContract);
window.sinuNeonUniPoolLocalContract        = sinuNeonUniPoolContract;
